// extracted by mini-css-extract-plugin
module.exports = {"cover":"FeaturedImage_cover__iGh1P","image":"FeaturedImage_image__hjFyR"};